const AudioLink = function (props) {
    return (
        <div className="audioLink">
            <div><strong>{props.data.Title}</strong></div>
            <div>{props.data.ArticleByLine}</div>
            <audio controls="controls">
                <source src={props.data.FileRef} type="audio/mpeg"></source> Your browser does not support the audio tag. 
            </audio>
            <br/>
        </div>
    );
}
export default AudioLink;
